import React, {useState, useEffect} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import Swal from 'sweetalert2'
import Modal from 'react-bootstrap/Modal';
import { BiSearch,BiTrash, BiEdit, BiCheck } from "react-icons/bi";
import axios from 'axios';

export default function Indicadores() {

    let carregou = false;
    useEffect(()=>{
        if(!carregou) {
            consultarAreas();
            consultarTipoUnidades();
            carregou = true;
        }
    }, []);

    const [inputs, setInputs] = useState({});
    const [indicadores, setIndicadores] = useState([]);
    const [indicadoresFilter, setIndicadoresFilter] = useState([]);
    //const [dimensoes, setDimensoes] = useState([]);
    //const [areas, setAreas] = useState([]);
    const [tipoUnidades, setTipoUnidades] = useState([]);
    const [modalIndicador, setModalIndicador] = useState(false);
    const [error, setErrors] = useState({});
    const [inputsDimensao, setInputsDimensao] = useState({});
    const [update, setUpdate] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("todos");

    const handledChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if(name === 'ativo') {
            if(value === 'true') setInputs(values => ({...values,[name]:true}));
            else setInputs(values => ({...values,[name]:false}));
        }
        else if(name === 'descricaoDimensao'){
            if(update)
                setInputsDimensao(values => ({...values,descricao:value,areas:[],ativo:true, delete:true}));
            else
                setInputsDimensao(values => ({...values,descricao:value,areas:[],ativo:true}));
        }
        else 
            setInputs(values => ({...values,[name]:value}));
    }

    const consultarIndicadores = (listDimensoes) => {
        axios.get(process.env.REACT_APP_API + 'Indicadores', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){

                response.data.value.forEach((responseIndicador, key) => {
                    let dimensao = listDimensoes.filter(d => {
                        return d.avaliacaoIndicador.avaliacaoIndicadorId === responseIndicador.avaliacaoIndicadorId
                    })
                    response.data.value[key].dimensoes = dimensao;
                })

                setIndicadores(response.data.value);  
                setIndicadoresFilter(response.data.value);  
                Swal.close();       
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarDimensao = (listAreas) => {
        axios.get(process.env.REACT_APP_API + 'Indicadores/Dimensoes', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){

                response.data.value.forEach((responseDimensao,key) => {
                    let area = listAreas.filter(a => {
                        return a.avaliacaoDimensao.avaliacaoDimensaoId === responseDimensao.avaliacaoDimensaoId
                    })
                    response.data.value[key].areas = area;
                });

                //setDimensoes(response.data.value);
                consultarIndicadores(response.data.value);
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarAreas = () => {
        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })

        axios.get(process.env.REACT_APP_API + 'Indicadores/Areas', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){
                //setAreas(response.data.value);
                consultarDimensao(response.data.value);
            }
            else 
            {
                Swal.close();
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarTipoUnidades = () => {
        axios.get(process.env.REACT_APP_API + 'TipoUnidades', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 200){
                setTipoUnidades(response.data.value);
            }
            else {
                Swal.close();
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const saveIndicador = () => {
        if(inputs.descricao === "") { setErrors({descricao:"Preencha a descrição"}); return; }
        if(inputs.descricao.length > 100) { setErrors({descricao:"A descrição deve ter até 100 caracteres"}); return; }
        if(inputs.tipoUnidadeId === "") { setErrors({tipoUnidadeId:"Preencha o tipo de unidade"}); return; }

        inputs.dimensoes.forEach(itemDimensao => {
            if(itemDimensao.descricao.length > 100) { setErrors({errosEixosObj:"A descrição das dimensões e objetivos devem ter até 100 caracteres"}); return; }
            itemDimensao.areas.forEach(itemArea => {
                if(itemArea.descricao.length > 100) { setErrors({errosEixosObj:"A descrição das dimensões e objetivos devem ter até 100 caracteres"}); return; }
            })
        })

        let vazioDimensao = true;
        inputs.dimensoes.forEach(item => {
            vazioDimensao = false;
        })
        if(vazioDimensao) { setErrors({dimensoes:"Adicione dimensões ao indicador"}); return; }

        if(vazioDimensao === false) {
            let vazioArea = true;
            inputs.dimensoes.forEach(item => {
                vazioArea = true;
                item.areas.forEach(item2 => {
                    vazioArea = false
                })
            })
            if(vazioArea) { setErrors({dimensoes:"É necessário adicionar áreas para as dimensões"}); return; }
        }
        setErrors({});//limpar erros

        axios.post(process.env.REACT_APP_API + 'Indicadores', inputs, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode >= 400){
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'error',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
            else {
                let idIndicador = response.data.value;
                inputs.dimensoes.forEach((itemDimensao, keyDimensao) => {
                    //cadastrar dimensão
                    let dadosDimensao = {
                        descricao: itemDimensao.descricao,
                        websaiId:null,
                        regLock:false,
                        avaliacaoIndicadorId:idIndicador,
                        ativo:true
                    }
                    axios.post(process.env.REACT_APP_API + 'Indicadores/Dimensoes', dadosDimensao, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(responseDimensao)  {
                        if(responseDimensao.data.statusCode !== 400) {
                            //gravar aras da dimensão
                            itemDimensao.areas.forEach(itemArea => {
                                let idDimensao = responseDimensao.data.value;
                                let dadosArea = {
                                    descricao:itemArea.descricao,
                                    websaiId: null,
                                    regLock:false,
                                    avaliacaoDimensaoId:idDimensao,
                                    ativo:true
                                }
                                axios.post(process.env.REACT_APP_API + 'Indicadores/Areas', dadosArea, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}});
                            })
                        }
                    })
                })

                //mensagem de confirmação
                Swal.fire({
                    title: 'Aguarde...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer:5000,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                }).then(() => {
                    controleModalIndicador(false);//fechar modal indicador
                    //atualizar tabela
                    setIndicadores([]);
                    setIndicadoresFilter([]);
                    //setAreas([])
                    //setDimensoes([])
                    consultarAreas();
                })
                
            }
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const updateIndicador = () => {
        if(inputs.descricao === "") { setErrors({descricao:"Preencha a descrição"}); return; }
        if(inputs.descricao.length > 100) { setErrors({descricao:"A descrição deve ter até 100 caracteres"}); return; }
        if(inputs.tipoUnidadeId === "") { setErrors({tipoUnidadeId:"Preencha o tipo de unidade"}); return; }

        inputs.dimensoes.forEach(itemDimensao => {
            if(itemDimensao.descricao.length > 100) { setErrors({errosEixosObj:"A descrição das dimensões e objetivos devem ter até 100 caracteres"}); return; }
            itemDimensao.areas.forEach(itemArea => {
                if(itemArea.descricao.length > 100) { setErrors({errosEixosObj:"A descrição das dimensões e objetivos devem ter até 100 caracteres"}); return; }
            })
        })

        //atualizar indicador
        axios.put(process.env.REACT_APP_API + 'Indicadores/'+inputs.avaliacaoIndicadorId, inputs, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(responseIndicador) {
            //atualizar dimensões
            inputs.dimensoes.forEach(itemDimensao => {
                let dadosDimensao = {};
                if(typeof itemDimensao.avaliacaoDimensaoId === "undefined") {
                    //cadastrar dimensão
                    dadosDimensao = {
                        descricao:itemDimensao.descricao,
                        websaiId:null,
                        regLock:false,
                        avaliacaoIndicadorId:inputs.avaliacaoIndicadorId,
                        ativo:true
                    }
                    axios.post(process.env.REACT_APP_API + 'Indicadores/Dimensoes/', dadosDimensao, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(responseDimensao) {
                        //atualizar áreas
                        inputs.dimensoes.forEach(itemDimensao => {
                            itemDimensao.areas.forEach(itemArea => {  
                                if(typeof itemArea.avaliacaoAreaId === "undefined") {  
                                    //cadastrando área
                                    let dadosArea = {
                                        descricao:itemArea.descricao,
                                        websaiId:null,
                                        regLock:false,
                                        avaliacaoDimensaoId:responseDimensao.data.value,
                                        ativo:true
                                    }
                                    axios.post(process.env.REACT_APP_API + 'Indicadores/Areas/', dadosArea, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                                    .then(function(responseArea) {});
                                }
                            })
                        })
                    });
                }
                else {
                    //atualizar dimensão
                    dadosDimensao = {
                        descricao:itemDimensao.descricao,
                        websaiId:itemDimensao.websaiId,
                        regLock:itemDimensao.regLock,
                        avaliacaoIndicadorId:itemDimensao.avaliacaoIndicador.avaliacaoIndicadorId,
                        ativo:itemDimensao.ativo
                    }
                
                    axios.put(process.env.REACT_APP_API + 'Indicadores/Dimensoes/'+itemDimensao.avaliacaoDimensaoId, dadosDimensao, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(responseDimensao) {
                        //atualizar áreas
                        inputs.dimensoes.forEach(itemDimensao => {
                            itemDimensao.areas.forEach(itemArea => {
                                let dadosArea = {};
                                if(typeof itemArea.avaliacaoAreaId === "undefined") {
                                    //cadastrando área
                                    dadosArea = {
                                        descricao:itemArea.descricao,
                                        websaiId:null,
                                        regLock:false,
                                        avaliacaoDimensaoId:itemDimensao.avaliacaoDimensaoId,
                                        ativo:true
                                    }
                                    axios.post(process.env.REACT_APP_API + 'Indicadores/Areas/', dadosArea, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                                    .then(function(responseArea) {});
                                }
                                else {
                                    //atualizando área
                                    dadosArea = {
                                        descricao:itemArea.descricao,
                                        websaiId:itemArea.websaiId,
                                        regLock:itemArea.regLock,
                                        avaliacaoDimensaoId:itemDimensao.avaliacaoDimensaoId,
                                        ativo:itemArea.ativo
                                    }
                                    axios.put(process.env.REACT_APP_API + 'Indicadores/Areas/'+itemArea.avaliacaoAreaId, dadosArea, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                                    .then(function(responseArea) {});
                                }
                            })
                        })
                    });
                }
            })

            Swal.fire({
                title: 'Aguarde...',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer:5000,
                didOpen: () => {
                    Swal.showLoading();
                }
            }).then(() => {
                controleModalIndicador(false);//fechar modal indicador
                //atualizar tabela
                setIndicadores([]);
                setIndicadoresFilter([]);
                //setAreas([])
                //setDimensoes([])
                consultarAreas();
            })
            

        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
        
    }

    const editarDescricaoArea = (event,key,keyArea) => {
        let updatedItems = inputs;
        updatedItems.dimensoes[key].areas[keyArea].descricao = event.target.value;
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const adicionarArea = (keyDimensao) => {
        let updatedItems = inputs;
        if(update)
            updatedItems.dimensoes[keyDimensao].areas.push({idDimensao:keyDimensao,descricao:"",ativo:true,avaliacaoDimensaoId:updatedItems.dimensoes[keyDimensao].avaliacaoDimensaoId,delete:true});
        else
            updatedItems.dimensoes[keyDimensao].areas.push({idDimensao:keyDimensao,descricao:"",ativo:true});
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const adicionarDimensao = () => {
        setErrors({});
        if(inputsDimensao.descricao === null || inputsDimensao.descricao === "") {setErrors({descricaoDimensao:"Preencha a descrição do eixo"}); return;}
        if(inputsDimensao.descricao.length >= 100) {setErrors({descricaoDimensao:"A descrição do eixo deve ter até 100 caracteres"}); return;}

        let updatedItems = inputs;
        updatedItems.dimensoes.push(inputsDimensao);
        setInputs(updatedItems);
        setInputsDimensao({descricao:""});
    }

    const removerArea = (key, keyArea) => {
        let updatedItems = inputs;
        delete updatedItems.dimensoes[key].areas[keyArea];
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const removerDimensao = (key) => {
        let updatedItems = inputs;
        delete updatedItems.dimensoes[key];
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const controleModalIndicador = (state) => {
        setErrors({});
        setUpdate(false);
        setInputs({
            descricao:"",
            tipoUnidadeId:"",
            websaiId:null,
            regLock:false,
            ativo:true,
            dimensoes:[]
        });
        setInputsDimensao({descricao:null});
        setModalIndicador(state);

        if(!state && update){
            //atualizar tabela
            setIndicadores([]);
            setIndicadoresFilter([]);
            //setAreas([])
            //setDimensoes([])
            consultarAreas();
        }
    }

    const editarIndicador = (i) => {
        console.log(i)
        setUpdate(true);
        setInputs({
            avaliacaoIndicadorId:i.avaliacaoIndicadorId,
            descricao:i.descricao,
            dimensoes:i.dimensoes,
            tipoUnidadeId:i.tipoUnidade.tipoUnidadeId,
            websaiId:i.websaiId,
            regLock:i.regLock,
            ativo:i.ativo
        })
        setModalIndicador(true);
    } 

    const editarDescricaoDimensao = (event, keyDimensao) => {
        let updatedItems = inputs;
        updatedItems.dimensoes[keyDimensao].descricao = event.target.value;
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const editarAtivo = (ativo, keyDimensao, keyArea) => {
        let updatedItems = inputs;
        if(ativo)
            updatedItems.dimensoes[keyDimensao].areas[keyArea].ativo = false;
        else
            updatedItems.dimensoes[keyDimensao].areas[keyArea].ativo = true;
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const editarDimensao = (ativo, keyDimensao) => {
        let updatedItems = inputs;
        if(ativo){
            updatedItems.dimensoes[keyDimensao].ativo = false;
            updatedItems.dimensoes[keyDimensao].areas.forEach((itemArea,keyArea) => {
                updatedItems.dimensoes[keyDimensao].areas[keyArea].ativo = false; 
            })
        }
        else{
            updatedItems.dimensoes[keyDimensao].ativo = true;
            updatedItems.dimensoes[keyDimensao].areas.forEach((itemArea,keyArea) => {
                updatedItems.dimensoes[keyDimensao].areas[keyArea].ativo = true; 
            })
        }
        setInputs(updatedItems);
        setInputsDimensao({descricao:null});
    }

    const filtrarTipoUnidade = (tipoUnidadeId) => {
        setSelectedFilter(tipoUnidadeId);
        if(tipoUnidadeId !== "todos") {
            let updatedItems = [...indicadores];
            const filtered = updatedItems.filter(item => {
                return item.tipoUnidade.tipoUnidadeId === tipoUnidadeId
            });

            setIndicadoresFilter(filtered);
        }
        else {
            let updatedItems = [...indicadores];
            setIndicadoresFilter(updatedItems);
        }
    }

    const filtrarPorDescricao = (event) => {
        if(selectedFilter === "todos") {
            let updatedItems = [...indicadores];
            const filtered = updatedItems.filter(item => {
                return item.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setIndicadoresFilter(filtered);
        }
        else {
            let updatedItems = [...indicadores];
            const filtered = updatedItems.filter(item => {
                return item.tipoUnidade.tipoUnidadeId === selectedFilter && item.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setIndicadoresFilter(filtered);
        }
    }

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">LISTA DE EIXOS</p>
                            <p className="text-center">Gerencie aqui os eixos, dimensões e objetivos.</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border text-center table-responsive">
                            <div className={"mb-2 text-center"}>
                                <button className='btn btn-custom btn-sm' onClick={() => controleModalIndicador(true)}>Novo Eixo</button>
                            </div>
                            <div className={"bg-white rounded p-3 border mb-2"}>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping"><BiSearch /></span>
                                    <input type="text" className="form-control" placeholder="Filtrar por eixo..." onChange={filtrarPorDescricao}/>
                                    
                                    <button className={selectedFilter === "todos" ? "btn btn-secondary":"btn btn-light border"} onClick={() => filtrarTipoUnidade("todos")}>Todos</button>
                                    {
                                        tipoUnidades.map((itemTipo,keyTipo) => 
                                            <button key={"itemTipo"+keyTipo} className={selectedFilter === itemTipo.tipoUnidadeId ? "btn btn-secondary":"btn btn-light border"} onClick={() => filtrarTipoUnidade(itemTipo.tipoUnidadeId)}>{itemTipo.descricao}</button>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                {
                                    indicadoresFilter.map((i, key) => 
                                    <div className="col-sm-12 shado">
                                        <div className="card mb-2 shadow">
                                            <div className="card-header">
                                                <span className="fw-bold fs-5">Eixo: {i.descricao}</span>
                                                <br/>
                                                <small className={i.tipoUnidade.descricao === "Etec"?"text-primary":i.tipoUnidade.descricao === "Fatec"?"text-danger":i.tipoUnidade.descricao === "Adm"?"text-success":"text-secondary"}>Tipo de unidade: {i.tipoUnidade.descricao}</small>
                                            </div>
                                            <div className="card-body table-responsive">
                                                <table className="table table-bordered table-sm table-striped">
                                                    <thead>
                                                        <th>Dimensões</th>
                                                        <th className="text-start">Objetivos</th>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            i.dimensoes.map((d,keyD) => 
                                                            <tr>
                                                                <th className="align-middle">
                                                                {
                                                                    i.ativo ?
                                                                    <span>{d.descricao}</span>
                                                                    :null
                                                                }
                                                                </th>
                                                                <td className="text-start">
                                                                    {
                                                                        d.areas.map(a =>
                                                                                a.ativo ?
                                                                                <div>
                                                                                    <BiCheck size={20} /> {a.descricao}
                                                                                </div>
                                                                                :null
                                                                        )
                                                                    }
                                                                </td>
                                                            </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                                <button type="button" className="btn btn-custom btn-sm col-4" onClick={() => editarIndicador(i)}><BiEdit /> Editar</button>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                }
                            </div>
                            
                        
                            </div>

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Modal size="lg" show={modalIndicador} onHide={() => controleModalIndicador(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{update ? "Editar item":"Novo item"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="card mb-2">
                        <div className="card-header">
                            Eixo
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="mb-2 col-lg-12">
                                    <label>Descrição do eixo</label>
                                    <input type="text" name="descricao" value={inputs.descricao} className="form-control" onChange={handledChange} disabled={inputs.regLock ? true : false}/> 
                                    <span className='text-danger'>{error.descricao}</span>
                                </div>
                                <div className="mb-2 col-lg-12">
                                    <label>Tipo de Unidade</label>
                                    <select className="form-control" name="tipoUnidadeId" onChange={handledChange} disabled={inputs.regLock ? true : false}>
                                        <option>Selecione</option>
                                        {
                                            tipoUnidades.map((item,keyTipoUnidade) => 
                                                <option key={"tipoUnidade"+keyTipoUnidade} value={item.tipoUnidadeId} selected={item.tipoUnidadeId === inputs.tipoUnidadeId ? "selected":null}>{item.descricao}</option>
                                            )
                                        }
                                    </select>
                                    <span className='text-danger'>{error.tipoUnidadeId}</span>
                                </div>
                                <div className="mb-2">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="ativo" value={inputs.ativo?false:true} onChange={handledChange} checked={inputs.ativo} disabled={inputs.regLock ? true : false}/>
                                        <label className="form-check-label">Ativo</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            Dimensões / Objetivos
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="mb-2 col-lg-12">
                                    <label>Descrição da dimensão</label>
                                    <div className="input-group">
                                        <input type="text" className="form-control" name="descricaoDimensao" value={inputsDimensao.descricao} onChange={handledChange}/>
                                        <button className="btn btn-outline-secondary" type="button" onClick={adicionarDimensao}>Adicionar dimensão</button>
                                    </div>
                                    <span className='text-danger'>{error.descricaoDimensao}</span>
                                    {typeof error.errosEixosObj !== "undefined" ? <div className="alert alert-warning mt-2"><strong>Atenção!</strong> {error.errosEixosObj}</div> : null}
                                </div>
                                <div className="col-sm-12">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Dimensões</th>
                                                <th>Objetivos</th>
                                                {
                                                    update?<th>Ativo</th>:null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                typeof inputs.dimensoes !== 'undefined'?
                                                inputs.dimensoes.map((itemDimensao, key) =>
                                                    <tr key={"itemDimensao"+key}>
                                                        <th>
                                                            <input type="text" className="form-control" name="descricaoDimensao" value={itemDimensao.descricao} onChange={(event) => editarDescricaoDimensao(event, key)} disabled={itemDimensao.regLock ? true : itemDimensao.ativo ? false:true}/>
                                                        </th>
                                                        <td className="align-middle text-center">
                                                            {
                                                            itemDimensao.ativo ?
                                                            <div className="d-grid gap-2 mb-2">
                                                                <button className="btn btn-custom btn-sm" type="button" onClick={() => adicionarArea(key)}>Adicionar objetivo</button>
                                                            </div>
                                                            :null
                                                            }
                                                            {
                                                                itemDimensao.areas.map((itemArea, keyArea) => 
                                                                    !itemArea.delete && update?
                                                                    <div className="input-group mb-1" key={"itemArea"+keyArea}>
                                                                        <input type="text" className="form-control form-control-sm" value={itemArea.descricao} onChange={(event) => editarDescricaoArea(event, key,keyArea)} disabled={itemArea.regLock ? true : itemDimensao.ativo?false:true} placeholder="Escreva aqui o objetivo"/>                                                                        
                                                                        {
                                                                            itemArea.regLock ? null :
                                                                            itemDimensao.ativo?<label className={itemArea.ativo ? "btn btn-success":"btn btn-outline-success"} onClick={() => editarAtivo(itemArea.ativo, key,keyArea)}>{itemArea.ativo?"Ativo":"Inativo"}</label>:null
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className="input-group mb-1" key={"itemArea"+keyArea}>
                                                                        <input type="text" className="form-control form-control-sm" value={itemArea.descricao} onChange={(event) => editarDescricaoArea(event, key,keyArea)} placeholder="Escreva aqui o objetvo"/>
                                                                        <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => removerArea(key, keyArea)}><BiTrash size={20}/></button>
                                                                    </div>
                                                                )
                                                            }
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            {
                                                            itemDimensao.delete || !update ?
                                                            <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => removerDimensao(key)}><BiTrash size={20}/> Remover dimensão</button>
                                                            :
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" role="switch" checked={itemDimensao.ativo} onClick={() => editarDimensao(itemDimensao.ativo,key)} disabled={itemDimensao.regLock ? true : false}/>
                                                            </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                ):null
                                            }
                                   
                                        </tbody>
                                    </table>
                                    <span className='text-danger'>{error.dimensoes}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="btn-group mt-2" role="group" aria-label="Basic example">
                        <button type="button" className="btn btn-custom" onClick={update ? updateIndicador : saveIndicador}>Gravar</button>
                        <button type="button" className="btn btn-light border" onClick={() => controleModalIndicador(false)}>Fechar</button>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
    
}